module.exports = __webpack_public_path__ + "img/recommed-img8.93f1930f.jpg";